import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';


import AdministratorsTable from './components/AdministratorsTable';
import AddAdministratorForm from './components/AddAdministratorForm';

import ListGrid from '../../../../common/components/ListGrid/ListGrid';
import TableWrapper from '../../../../common/components/TableWrapper/TableWrapper';
import ListActions from '../../../../common/components/ListActions';
import Title from '../../../../common/components/Title';
import Modal from '../../../../common/components/Modal';
import {OrdersBundle} from "../../../../utils/ordersBundle";
import {hetch} from "../../../../utils/fetch.hooked";

function Administrators({ permission }) {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState(query.get('pageNumber') ?? 1);
  const [count, setCount] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [rows, setRows] = useState(null);
  const [roles, setRoles] = useState(null);
  const [sortOrders, setSortOrders] = useState('');

  const ordersBundle = new OrdersBundle({
        family_name: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        first_name: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        patronymic: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        login: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        workPosition: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        role: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        email: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        expired_license: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        expired_key: { firstDirection: 'asc', direction: useState('none'), index: useState(0) },
        enable: { firstDirection: 'asc', direction: useState('none'), index: useState(0) }
    }, sortOrders, setSortOrders)

  const handleAddModalClose = () => setAddModalOpen(false);
  const triggerRefetch = () => setRefetch(refetch => !refetch);
  const buildSearchParams = () => {
      let p = {
          pageNumber: page,
          pageSize: pageSize,
      };
      if (sortOrders.length > 0) {
          p.sortFields = sortOrders;
      }
      return new URLSearchParams(p).toString();
  }

  useEffect(() => {
    history.push({
      search: `pageNumber=${page}`
    })
  }, [history, page]);

  useEffect(() => {
    const fetchData = () => {
      setIsFetching(true);
      if(roles === null) {
          Promise.all([
              hetch(`/api/administrators?` + buildSearchParams()).then(res => res.json()),
              hetch(`/api/roles`).then(res => res.json()),
              hetch(`/api/sessions`).then(res => res.json())
          ])
              .then(([usersRes, rolesRes]) => {
                  setRoles(rolesRes?.content ?? []);
                  setRows(usersRes?.content ?? []);
                  setCount(Math.ceil(usersRes.total / usersRes.pageSize));
              })
              .finally(() => {
                  setIsFetching(false);
              });
      } else {
          hetch(`/api/administrators?` + buildSearchParams())
              .then(res => res.json())
              .then((usersRes) => {
                  setRows(usersRes?.content ?? []);
                  setCount(Math.ceil(usersRes.total / usersRes.pageSize));
              })
              .finally(() => {
                  setIsFetching(false);
              });
      }
    }

    fetchData();
  }, [page, pageSize, sortOrders, refetch]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <ListGrid
        header={(
          <Title
            title="Список учетных записей"
            actions={(
              <ListActions
                addTitle="Добавить учетную запись"
                refreshTitle="Обновить список учетных записей"
                onAddClick={() => setAddModalOpen(true)}
                permission={permission}
                isRefreshing={isFetching}
                onRefreshClick={() => triggerRefetch(refetch => !refetch)}
                pageSizes = {[25, 50, 100]}
                pageSize={pageSize}
                onPageSizeChange={(size) => setPageSize(size)}
              />
            )}
          />
        )}
        body={(
          <TableWrapper
            rows={rows}
            count={count}
            page={page}
            emptyAlertText="Список учетных записей пуст"
            isFetching={isFetching}
            onChange={handleChange}
          >
            <AdministratorsTable ordersBundle={ordersBundle} permission={permission} roles={roles} rows={rows} triggerRefetch={triggerRefetch}/>
          </TableWrapper>
        )}
      />
      <Modal
        header="Добавление учетной записи"
        width={700}
        open={addModalOpen}
        onClose={handleAddModalClose}
      >
        <AddAdministratorForm roles={roles} triggerRefetch={triggerRefetch} handleClose={handleAddModalClose}/>
      </Modal>
    </>
  );
}

export default Administrators;
